export function WorkflowsPage() {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-lg font-semibold text-secondary-900 dark:text-white">Workflows</h2>
          <p className="text-sm text-secondary-500">Automatisez vos processus métier</p>
        </div>
        <button className="rounded-lg bg-primary-500 px-4 py-2 text-sm font-medium text-white hover:bg-primary-600">
          Nouveau Workflow
        </button>
      </div>

      <div className="rounded-xl border border-secondary-200 bg-white dark:border-secondary-800 dark:bg-secondary-900">
        <table className="w-full">
          <thead>
            <tr className="border-b border-secondary-200 dark:border-secondary-800">
              <th className="px-6 py-3 text-left text-xs font-medium uppercase text-secondary-500">
                Nom
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium uppercase text-secondary-500">
                Application
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium uppercase text-secondary-500">
                Trigger
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium uppercase text-secondary-500">
                Statut
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium uppercase text-secondary-500">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-secondary-200 dark:divide-secondary-800">
            {[
              {
                name: 'Approbation Congés',
                app: 'Gestion RH',
                trigger: 'Manual',
                status: 'active',
              },
              {
                name: 'Validation Permis',
                app: 'Permis de Construire',
                trigger: 'Event',
                status: 'active',
              },
              {
                name: 'Traitement Réclamation',
                app: 'Réclamations',
                trigger: 'Event',
                status: 'draft',
              },
            ].map((workflow) => (
              <tr key={workflow.name}>
                <td className="px-6 py-4 text-sm font-medium text-secondary-900 dark:text-white">
                  {workflow.name}
                </td>
                <td className="px-6 py-4 text-sm text-secondary-500">{workflow.app}</td>
                <td className="px-6 py-4 text-sm text-secondary-500">{workflow.trigger}</td>
                <td className="px-6 py-4">
                  <span
                    className={`rounded-full px-2 py-1 text-xs font-medium ${
                      workflow.status === 'active'
                        ? 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400'
                        : 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400'
                    }`}
                  >
                    {workflow.status === 'active' ? 'Actif' : 'Brouillon'}
                  </span>
                </td>
                <td className="px-6 py-4">
                  <button className="text-sm text-primary-600 hover:text-primary-700">
                    Modifier
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
